enum ActionTypes {
    STATUS_REPORT_REQUEST = 'dashboard/STATUS_REPORT_REQUEST',
    STATUS_REPORT_SUCCESS = 'dashboard/STATUS_REPORT_SUCCESS',
    STATUS_REPORT_FAILED = 'dashboard/STATUS_REPORT_FAILED',
}

export default ActionTypes;